// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4d14c3fb","239":"dfe6393c","453":"1df44d83","455":"afd0c89f"}[chunkId] + ".chunk.js";
};